import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ajaxGetSuppliers } from '../../services/supplierService';
import Page from '../../components/Page';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import EnhancedTable from '../../components/EnhancedTable'
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';


export default function SupplierList() {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  const columns = [
    { id: 'name', label: 'Name', sortable: true },
    { id: 'contact_person', label: 'Contact Person', sortable: true },
    { id: 'supplier2303', label: 'Supplier 2303/TIN#', sortable: true },
    { 
      id: 'address',
      label: 'Address',
      sortable: true,
      format: (v)=><div style={{whiteSpace: 'pre-line'}}>{v}</div>
    },
    { id: 'email', label: 'E-mail', sortable: true },
    { id: 'phone', label: 'Contact Phone', sortable: true },
    { id: 'bank_details', label: 'Bank Details', sortable: true }
  ];

  useEffect(() => {
    ajaxGetSuppliers({})
      .then((res) => {
        const { data } = res;
        setItems(data);
      })
      .catch(() => {
        setItems([]);
      });
  }, []);

  const searchChangeHandle = (event) => {
    const new_value = event.target.value.toLowerCase();
    setSearchTerm(new_value);
  };

  useEffect(() => {
    const results = items.filter((item) => `${(item.name || '')}${(item.contact_person || '')}${(item.supplier2303 || '')}${(item.address || '')}${(item.email || '')}${(item.phone || '')}${(item.bank_details || '')}`.toLowerCase().includes(searchTerm));
    setSearchResults(results);
  }, [searchTerm, items]);

  return (
    <Page title="Suppliers" maxWidth={false} sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        <Grid xs={12} item>
          <TextField
            fullWidth
            size="small"
            type="text"
            label="Search"
            placeholder="Search keyword"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onChange={searchChangeHandle}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </Grid>
      </Box>
      <Box>
        <Grid xs={12} item>
          <Button
            size="small"
            variant="contained"
            color="info"
            sx={{ margin: '10px 0' }}
            startIcon={<AddIcon />}
            onClick={() => navigate('/suppliers/add')}
          >
            New supplier
          </Button>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Box sx={{ position: 'absolute', inset: '0px 0px 10px 0px' }}>
          <EnhancedTable border fullHeight stickyColumn fontSize="12px" columns={columns} items={searchResults} onRowClick={(id)=>navigate('/suppliers/edit/'+id)}/>
        </Box>
      </Box>
    </Page>
  );
}
